// extracted by mini-css-extract-plugin
export default {"review":"SingleReview_review__vl4Bi","avatar":"SingleReview_avatar__3CTC4","period":"SingleReview_period__BnWsV","stars":"SingleReview_stars__rfc5-"};